import React, { HTMLAttributes, ReactNode } from "react";
import classnames from "classnames";

import { Icon } from "../../../../../components/icon/Icon";

import "./UploadCsvNotification.scss";

export enum CsvNotificationType {
  Info = "info",
  Warning = "warning",
  Error = "error",
}

const a11yConfig: Record<
  CsvNotificationType,
  HTMLAttributes<HTMLDivElement>
> = {
  [CsvNotificationType.Info]: {},
  [CsvNotificationType.Warning]: {
    role: "alert",
    "aria-atomic": "true",
  },
  [CsvNotificationType.Error]: {
    role: "alert",
    "aria-atomic": "true",
  },
};

interface UploadCsvNotificationProps {
  type: CsvNotificationType;
  children: ReactNode;
}

export const UploadCsvNotification = ({
  children,
  type,
}: UploadCsvNotificationProps) => {
  return (
    <div className="upload-csv-notification" {...a11yConfig[type]}>
      <Icon className={getIconClassnames(type)} />
      <div className={getMessageClassnames(type)}>{children}</div>
    </div>
  );
};

const getIconClassnames = (type) => {
  const icons = {
    [CsvNotificationType.Info]: "fa-regular fa-info-circle color-primary",
    [CsvNotificationType.Warning]:
      "fa-solid fa-exclamation-triangle color-warning",
    [CsvNotificationType.Error]:
      "fa-solid fa-exclamation-triangle color-danger",
  };

  return classnames("upload-csv-notification__icon", icons[type]);
};

const getMessageClassnames = (type) => {
  const messages = {
    [CsvNotificationType.Info]: "",
    [CsvNotificationType.Warning]: "upload-csv-notification__message--warning",
    [CsvNotificationType.Error]: "upload-csv-notification__message--error",
  };

  return classnames("upload-csv-notification__message", messages[type]);
};
